import { combineReducers } from 'redux';
import putNicknameReducer from './putNicknameReducer';

const index = combineReducers({
  putNickname: putNicknameReducer,
});

export default index;
